import { Property } from "./property";
import { SystemField } from "./system-field"; 

export class Category  extends SystemField{
    
	ordering?:number;
	code?: string; 
	parent_id?:string;
	is_active?:number;
	icon?:string;
	image?:string;
	is_default?: boolean;
	slug?:string;
	not_delete?:number; 
	isEdit?: number;
    isInvalid?: number;
	item_type?: string;
    property_ids?: string;
	record_type_id?: string;
	record_type_name?:string;
	is_favorite?:number;
	sub_category_ids?:string;
	name?:string;
    

	//Formula Fields
	image_preview?:string;
	properties?: Property[];
	sub_categories?: Property[];
	
	// Import class translate
    langs?:any;
	record_type?: string;
	parent?:Category;
}

export class CategoryTranslate extends SystemField{
	lang_code?:string;
	categories_id?:string;
	name?:string;
	label?:string;
	short_desc?:string;
	note?:string;
}

export class PublicCategories extends Category{}